export default __webpack_public_path__ + "static/media/21.9e7bf5d2.jpg";